import { render } from "./benefit-consultants.vue?vue&type=template&id=03bad880&scoped=true&ts=true"
import script from "./benefit-consultants.vue?vue&type=script&lang=ts"
export * from "./benefit-consultants.vue?vue&type=script&lang=ts"

import "./benefit-consultants.vue?vue&type=style&index=0&id=03bad880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bad880"]])

export default __exports__